<mat-menu #overflowMenu="matMenu">
    <a mat-menu-item (click)="showAddPipeline()">
        <mat-icon>add</mat-icon>
        New
    </a>

    <mat-divider></mat-divider>


    <ng-container *ngIf="selectedPipeline && selectedPipeline.executionType === 'continuous'">
        <a mat-menu-item>
            <mat-checkbox [(ngModel)]="pipelineEnabled">
                Enabled
            </mat-checkbox>
        </a>
    </ng-container>
    
    <ng-container *ngIf="getSessionState(pipelineSession) !== 'running'">
        <ng-container *ngIf="['success', 'not-started'].includes(getSessionState(pipelineSession))">
            <a mat-menu-item (click)="enablePipeline()" [disabled]="!selectedPipeline">
                <mat-icon>play_arrow</mat-icon>
                Run
            </a>
        </ng-container>
        <ng-container *ngIf="['error'].includes(getSessionState(pipelineSession))">
            <a mat-menu-item (click)="enablePipeline()" [disabled]="!selectedPipeline">
                <mat-icon>refresh</mat-icon>
                Run Again
            </a>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="getSessionState(pipelineSession) === 'running'">
        <a mat-menu-item (click)="disablePipeline()" [disabled]="!selectedPipeline">
            <mat-icon>stop</mat-icon>
            Stop
        </a>
    </ng-container>


    <a mat-menu-item (click)="removePipeline()" [disabled]="!selectedPipeline">
        <mat-icon>delete</mat-icon>
        Delete
    </a>

    <a mat-menu-item [disabled]="!selectedPipeline" (click)="editPipeline()">
        <mat-icon>edit</mat-icon>
        Settings
    </a>

    <a mat-menu-item [disabled]="!selectedPipeline || !graphDirty" (click)="saveGraph()">
        <mat-icon>save</mat-icon>
        Save
    </a>

</mat-menu>


<div class="loading" [class.visible]="loading">
    <mat-spinner></mat-spinner>
</div>

<!-- <a (click)="loading = true">LOAD</a>
<a (click)="loading = false">UNLOAD</a> -->

<div class="toolbar pipeline-selector">
    <mat-form-field appearance="outline" style="flex-grow: 1;">
        <mat-label>Pipeline</mat-label>
        <mat-select [(value)]="selectedPipelineID" placeholder="New Pipeline">
            <mat-option [value]="pipeline.id" *ngFor="let pipeline of pipelines">{{pipeline.name}}</mat-option>
        </mat-select>
    </mat-form-field>

    <a mat-icon-button [disabled]="!selectedPipeline || !graphDirty" (click)="saveGraph()">
        <mat-icon>save</mat-icon>
    </a>

    <ng-container *ngIf="runnable">
        <ng-container *ngIf="selectedPipeline.executionType === 'continuous'">
            <mat-checkbox class="pipeline-enabled" [(ngModel)]="pipelineEnabled">
                Enabled
            </mat-checkbox>
        </ng-container>
        <ng-container *ngIf="selectedPipeline.executionType !== 'continuous'">
            <ng-container *ngIf="getSessionState(pipelineSession) !== 'not-started'">
                <ng-container *ngIf="getSessionState(pipelineSession) === 'running'">
                    Running
                </ng-container>
                <ng-container *ngIf="getSessionState(pipelineSession) === 'error'">
                    Error
                </ng-container>
                <ng-container *ngIf="getSessionState(pipelineSession) === 'success'">
                    Success
                </ng-container>
            </ng-container>

            &nbsp;

            <ng-container *ngIf="getSessionState(pipelineSession) !== 'running'">
                <ng-container *ngIf="['success', 'not-started'].includes(getSessionState(pipelineSession))">
                    <button class="run-btn" mat-raised-button color="primary" (click)="enablePipeline()">
                        <mat-icon>play_arrow</mat-icon>
                        Run
                    </button>
                </ng-container>
                <ng-container *ngIf="['error'].includes(getSessionState(pipelineSession))">
                    <button mat-raised-button color="primary" (click)="enablePipeline()">
                        <mat-icon>refresh</mat-icon>
                        Run Again
                    </button>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="getSessionState(pipelineSession) === 'running'">
                <button mat-raised-button color="primary" (click)="disablePipeline()">
                    <mat-icon>stop</mat-icon>
                    Stop
                </button>
            </ng-container>
        </ng-container>
    </ng-container>

    <a mat-icon-button [matMenuTriggerFor]="overflowMenu">
        <mat-icon>more_vert</mat-icon>
    </a>
</div>

<ng-container *ngIf="!selectedPipeline">
    Select a pipeline above to start.
</ng-container>

    <mat-tab-group #tabs *ngIf="selectedPipelineID" [(selectedIndex)]="selectedTabIndex"> 
        <mat-tab label="Graph">

            <div class="hsplitter">
                <aside class="errors" [class.visible]="footerVisible">
                    <div class="scroller">
                        <ng-container *ngIf="selectedPipeline?.errors?.length > 0">
                            <h1>Errors</h1>
                            <div class="error-list small-error-list">
                                <a href="javascript:;" 
                                    (click)="switchToError(error)" 
                                    class="error" 
                                    [class.warning]="error.type === 'warning'" 
                                    [class.info]="error.type === 'info'" 
                                    *ngFor="let error of selectedPipeline.errors"
                                    >
                                    {{error.message}}
                                </a>
                            </div>
                        </ng-container>
                    </div>
                </aside>
                <dz-editor 
                    [style.display]="selectedPipeline ? 'initial' : 'none'"
                    [providers]="providers"
                    [active]="pipelineSession && !pipelineSession.ended"
                    [readonly]="pipelineSession && !pipelineSession.ended"
                    [graph]="selectedPipeline?.graph || defaultGraph"
                    [availableNodes]="availableNodes"
                    [optionSources]="dynamicOptionSources"
                    [customPropertyTypes]="customPropertyTypes"
                    [universalPropertySets]="universalPropertySets"
                    [valueTypes]="valueTypes"
                    [nodeTypeMap]="nodeTypeMap"
                    (graphChanged)="onGraphChanged($event)"
                    (contextChanged)="graphContext = $event"
                    (saveRequested)="saveGraph()"
                    ></dz-editor>
            </div>
        </mat-tab>

        <mat-tab #errorTab label="Errors" *ngIf="selectedPipeline?.errors?.length > 0">

            <div class="error-list large">
                <mat-form-field appearance="outline" style="width: 100%;">

                    <mat-icon matPrefix>search</mat-icon>

                    <mat-label>
                        Search
                    </mat-label>
    
                    <input type="text" matInput [(ngModel)]="errorSearchQuery" />
                    
                    <button mat-icon-button matSuffix *ngIf="errorSearchQuery" (click)="errorSearchQuery = ''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
        
                <div class="empty" *ngIf="!selectedPipeline?.errors?.length">
                    <h1>Nothing to show</h1>
                    <p>No errors were detected while compiling the graph for this pipeline.</p>
                </div>

                <ng-container *ngIf="selectedPipeline?.errors?.length > 0">
                    <ng-container *ngFor="let error of selectedPipeline.errors | omnisearch: errorSearchQuery">
                        <ng-container *ngIf="error === null">
                            <div class="empty">
                                <h1>No matching errors</h1>
                                <p>Revise your search query or clear the search box to see all errors.</p>

                                <div class="note">
                                    Examples:
                                    <ul>
                                        <li><code>searchterm1 searchterm2 ...</code> -- Rank results on the given search terms</li>
                                        <li><code>/regex.*/ig</code> -- Use a regular expression</li>
                                        <li><code>$.foo.bar searchterm1 ...</code> -- Use a JSONPath expression to perform precise searches</li>
                                    </ul>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="error !== null">
                            <div class="error" 
                                [class.warning]="error.type === 'warning'" 
                                [class.info]="error.type === 'info'"
                                >
                                <h2><span [innerHTML]="error.message | trustHtml"></span></h2>
                                <ul class="facts">
                                    <li>
                                        <ng-container *ngIf="error.type === 'error' || !error.type">Error</ng-container>
                                        <ng-container *ngIf="error.type === 'warning'">Warning</ng-container>
                                        <ng-container *ngIf="error.type === 'info'">Information</ng-container>
                                    </li>
                                    <li *ngIf="error.code"><code>{{error.code}}</code></li>
                                    <li *ngIf="error.nodeId">Node <code>{{error.nodeId}}</code></li>
                                    <li *ngIf="error.slotId">Slot <code>{{error.nodeId}}</code></li>
                                </ul>
                                <div class="details" [innerHTML]="error.details | trustHtml"></div>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </mat-tab>

        <mat-tab label="Status" *ngIf="runnable">
            <ng-container *ngIf="pipelineSession">
                <h2>Session</h2>
                <div class="property">
                    <label>ID</label>
                    <code>{{pipelineSession.id}}</code>
                </div>
                <div class="property">
                    <label>Command</label>
                    <code>ffmpeg {{pipelineSession.ffmpegCommandLine.join(' ')}}</code>
                </div>
                <div class="property">
                    <label>Pipeline</label>
                    {{pipelineSession.description.name}} &nbsp; [<code>{{pipelineSession.description.id}}</code>]
                </div>
                <div class="property">
                    <label>Status</label>
                    <ng-container *ngIf="getSessionState(pipelineSession) === 'error'">
                        Ended with Error
                    </ng-container>
                    <ng-container *ngIf="getSessionState(pipelineSession) === 'success'">
                        Completed successfully
                    </ng-container>
                    <ng-container *ngIf="getSessionState(pipelineSession) === 'not-started'">
                        Not started
                    </ng-container>
                    <ng-container *ngIf="getSessionState(pipelineSession) === 'running'">
                        Running
                    </ng-container>
                </div>
                
                <mat-divider></mat-divider>
                <div class="property multi-line">
                    <label>Logs</label>
                    <pre>{{pipelineSession.logs.join("\n")}}</pre>
                </div>
                <mat-divider></mat-divider>
                <div class="property multi-line">
                    <label>Raw</label>
                    <pre>{{pipelineSession | json }}</pre>
                </div>
                
            </ng-container>
            <ng-container *ngIf="selectedPipeline && !pipelineSession">
                <div class="empty-session">
                    
                    <ng-container *ngIf="selectedPipeline.executionType === 'continuous'">
                        <ng-container *ngIf="selectedPipeline.enabled">
                            <h1>Not Running</h1>
                            <p>This pipeline is enabled. It will start as soon as the proper conditions 
                                are met.</p>
                        </ng-container>
                        <ng-container *ngIf="!selectedPipeline.enabled">
                            <h1>Disabled</h1>
                            <p>This pipeline is disabled. Check "Enable" above to enable it.</p>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="selectedPipeline.executionType === 'on-demand'">
                        <h1>Not running</h1>
                        <p>
                            The pipeline is not running. Choose "Run" above to start it.
                        </p>
                    </ng-container>
                    
                </div>
            </ng-container>
        </mat-tab>

        <mat-tab label="Analysis" *ngIf="selectedPipeline?.compilation?.debug">

            <div style="margin: 2em 0.5em;">
                <div class="property">
                    <label>Command Line</label>
                    <code *ngIf="selectedPipeline.commandLine">ffmpeg {{selectedPipeline.commandLine.join(' ')}}</code>
                    <em *ngIf="!selectedPipeline.commandLine">Unavailable</em>
                </div>

                <ul class="facts">
                    <li>{{selectedPipeline.compilation.inputs.length}} inputs</li>
                    <li>{{selectedPipeline.compilation.outputs.length}} outputs</li>
                </ul>
            </div>

            <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
                <mat-label>Step</mat-label>
                <mat-select [(ngModel)]="selectedStageIndex">
                    <mat-option 
                        *ngFor="let stage of selectedPipeline.compilation.debug.stages; index as i"
                        [value]="i"
                        >{{stage.label}}</mat-option>
                </mat-select>
            </mat-form-field>

            <ng-container *ngIf="selectedPipeline.compilation.debug.stages[selectedStageIndex]">
                <dz-editor 
                    [graph]="selectedPipeline.compilation.debug.stages[selectedStageIndex].graph"
                    [readonly]="true"
                    (graphChanged)="saveBackDebugGraph($event)"
                ></dz-editor>
            </ng-container>

        </mat-tab>

        <ng-container *ngIf="runnable">
            <mat-tab label="Router">

                <h1>Dynamic Entries</h1>
                <div class="entry" *ngFor="let entry of entries">
                    <a routerLink="/pipelines/{{entry.path.replace('/', '.')}}">{{entry.path}}</a>
                
                    <ng-container *ngIf="entry.watched && entry.available">
                        <span class="tag">Connected</span>
                    </ng-container>
                    <ng-container *ngIf="!entry.watched || !entry.available">
                        <span class="tag" *ngIf="entry.watched">
                            Watched
                        </span>
                        <span class="tag" *ngIf="entry.available">
                            Available
                        </span>
                    </ng-container>
                </div>

                <pre class="raw">{{entries | json}}</pre>
                

                <div class="toolbar">
                    <h1>Static Entries</h1>
                    <div class="spacer"></div>
                    <div class="actions">
                        <a mat-raised-button color="primary" (click)="newInput()">
                            <mat-icon>add</mat-icon>
                            Input
                        </a>
                        &nbsp;
                        <a mat-raised-button color="primary" (click)="newOutput()">
                            <mat-icon>add</mat-icon>
                            Output
                        </a>
                    </div>
                </div>


                <br/>

                <div class="fixed-entry" *ngFor="let fixedEntry of fixedEntries">
                    
                    <a mat-button (click)="editFixedEntry(fixedEntry)" class="overview">
                        <ng-container *ngIf="fixedEntry.type === 'input'">
                            <span class="tag identifier">
                                <label>{{fixedEntry.descriptor.type}}</label>
                                {{getLabelForFixedEntry(fixedEntry)}}
                            </span>
            
                            <mat-icon>arrow_forward</mat-icon>
            
                            <span class="tag identifier">
                                <label>router:</label>
                                {{fixedEntry.path}}
                            </span>
                    
                        </ng-container>
                        <ng-container *ngIf="fixedEntry.type === 'output'">
                            <span class="tag identifier">
                                <label>router:</label>
                                {{fixedEntry.path}}
                            </span>

                            <mat-icon>arrow_forward</mat-icon>

                            <span class="tag identifier">
                                <label>{{fixedEntry.descriptor.type}}</label>
                                {{getLabelForFixedEntry(fixedEntry)}}
                            </span>
                    
                                    
                        </ng-container>
                        
                    </a>
                </div>

                <pre class="raw">{{fixedEntries | json}}</pre>

            </mat-tab>
        </ng-container>
        <ng-container *ngIf="selectedPipeline?.executionType === 'reusable'">
            <mat-tab label="Usages">
                Shows which pipelines use this reusable pipeline
            </mat-tab>
        </ng-container>

        <mat-tab label="JSON" #jsonTab>
            <div class="editor-container" *ngIf="activeTab === jsonTab">
                <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="selectedPipelineJSON"></ngx-monaco-editor>
            </div>
            <!-- <pre>{{selectedPipeline | json}}</pre> -->
        </mat-tab>
    </mat-tab-group>


<div class="toolbar" *ngIf="selectedPipeline">
    <ul class="facts">
        <li>
            {{selectedPipeline.graph?.nodes?.length || 0}} nodes, 
            {{selectedPipeline.graph?.edges?.length || 0}} edges 
        </li>

        <li *ngIf="selectedPipeline.errors && selectedPipeline.errors.length > 0" style="color: maroon;">
            {{selectedPipeline.errors.length}} 
            <ng-container *ngIf="selectedPipeline.errors.length == 1">
                error
            </ng-container>
            <ng-container *ngIf="selectedPipeline.errors.length > 1">
                errors
            </ng-container>
        </li>

        <li>
            <ng-container *ngIf="pipelineSession">
                <ng-container *ngIf="pipelineSession.ended">
                    Ended
                </ng-container>
                <ng-container *ngIf="!pipelineSession.ended">
                    Running
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!pipelineSession">
                Not started
            </ng-container>
        </li>
    </ul>
</div>
